<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
        	<div class="col-md-2">
            <smallBar></smallBar>
          </div>
          <div class="col-md-10">
				    <div class="widget-wrap">
				    	<dateFilter :show_month=true :now_year="now_year" :now_month="now_month" :years="years" @changeYear="changeYear" @changeMonth="changeMonth"></dateFilter>
				    	<h4>
				    		<span>{{now_year}}年現金餘額明細</span>
				    	</h4>
				    	<div class="clear mb-3"></div>	
				    	<div v-for="year_budget in filtedYearBudget()">
				    		<input class="form-control mb-2" style="width:300px" v-model="year_budget.start_money" 
                  v-if="canEditColumn('start_money',year_budget.id)"
                  @keydown.enter="$event.target.blur()" 
                  v-on:blur="updateBudget(year_budget)"
                  v-bind:ref="('start_money'+year_budget.id)"
                >
				    		<span v-else @click="editColumn('start_money',year_budget.id)" class="pull-left pointer">年初現金：{{year_budget.start_money.toLocaleString()}} <i class="fa fa-pencil-alt"></i></span>

				    		<table class="table table-bordered table-striped">
	              	<tr>
	              		<th class="text-center">名稱</th>
	              		<th class="text-center">類型</th>
	              		<th class="text-center">收付時間</th>
	              		<th class="text-center">金額</th>
	              		<th class="text-center">現金餘額</th>
	              	</tr>
	              	<tr v-for="money in filtedMoneys()">
	              		<td>{{money.title}}</td>
	              		<td>{{getMoneyType(money.money_type)}}</td>
	              		<td>{{money.finish_at}}</td>
	              		<td><span v-html="price_format(money)"></span></td>
	              		<td>{{money.sum.toLocaleString()}}</td>
	              	</tr>
	              </table>
				    	</div>
				    </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import smallBar from './SmallBar.vue';
import dateFilter from './DateFilter.vue';
import moment from 'moment';

export default {
  name: 'cash_flow_history',
  data() {
    return {
    	year_budgets: [],
    	years: [],
    	moneys: [],
    	now_year: new Date().getFullYear(),
    	now_month: new Date().getMonth(),
    	editColumnName: "",
      editColumnId: "",
      months: [],
      temp_moneys: [],
    }
  },
  created() {
  	this.createMonthDaysData()
    this.getYearBudgets()
  },
  components: {
    smallBar,dateFilter
  },
  props: ['toggle_aside'],
  methods: {
  	createMonthDaysData(){
  		let vm = this
			for (var i = 1; i <= 12; i++) {
			    vm.months.push(i);
			}
  	},
  	canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[name+id])){
          vm.$refs[name+id][0].focus()
        }else{
          vm.$refs[name+id].focus()
        }
      })
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
  	

    getYearBudgets(){
      let vm = this
      this.axios.get('finances/year_budgets')
      .then(function(response) {
        if (response.status == 200) {
          vm.year_budgets = response['data']['data']['current_collection']
          vm.years = response['data']['data']['years']
          vm.getMoneys()
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    getMoneys(){
      let vm = this
      this.axios.get('finance_moneys')
      .then(function(response) {
        if (response.status == 200) {
          vm.moneys = response['data']['data']['finance_moneys']
          vm.calculateMoneySum()
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    filtedYearBudget(){
    	let vm = this
    	var result = this.year_budgets.filter(m => m.year == vm.now_year)
    	return result
    },
    calculateMoneySum(){
    	//計算餘額，並且塞進每個money裡面
    	let vm = this;
    	vm.temp_moneys = _.orderBy(this.moneys.filter(m => (m.money_type == 'received' || m.money_type == 'paid') && new Date(m.finish_at).getFullYear() == vm.now_year),"finish_at")
    	if(vm.filtedYearBudget()[0]){
	    	var sum =  vm.filtedYearBudget()[0].start_money

	    	vm.temp_moneys.forEach(function(val) {
	        if(val.money_type == "received"){
	    			//收入，+
	    			sum += val.amount
	    		}else{
	    			//支出，-
	    			sum -= val.amount
	    		}
	    		val['sum'] = sum 
	      })
		  }
    },
    filtedMoneys(){
    	let vm = this
    	//過濾月款項
    	if(this.now_month=='all'){
    		return this.temp_moneys
    	}else{
    		return this.temp_moneys.filter(m => new Date(m.finish_at).getMonth()+1 == this.now_month)
    	}
    },
    updateItem(item){
    	let vm = this
    	vm.finishedEditColumn()
    	this.axios.put('finances/year_budgets_items/'+item.id, {
        year_budget_item: item,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success') {
          
        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
		    );
      });
    },
    
    
    updateBudget(year_budget){
    	let vm = this
    	vm.finishedEditColumn()
    	vm.calculateMoneySum()
    	this.axios.put('finances/year_budgets/'+year_budget.id , {
        year_budget: year_budget,
      })
      .then(function(response) {
      	console.log(response.status,response['data']['status'])
        if(response.status == 200 && response['data']['status']== 'success'){
          
        } else {
        	vm.temp_template.loading = false
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
      	vm.temp_template.loading = false
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
		    );
      });
    },
    // getInvoiceStatus(status){
    // 	switch(status){
    // 		case 'no_invoice':
    // 			return '無發票'
    // 		case 'not_create':
    // 			return '尚未開立'
    // 		case 'created':
    // 			return '已開發票'
    // 	}
    // },
    getMoneyType(type){
    	switch(type){
    		case 'received':
    			return '收入'
    		case 'paid':
    			return '支出'
    	}
    },
    changeYear(year){
    	this.now_year = year
    	this.calculateMoneySum()
    },
    changeMonth(month){
    	this.now_month = month
    	this.calculateMoneySum()
    },
    price_format(money){
    	if(money.money_type == "received"){
    		return "<span class='text-danger'>+ "+money.amount.toLocaleString()+"</span>"
    	}else{
    		return "<span class='text-success'>- "+money.amount.toLocaleString()+"</span>"
    	}
    }
  }
}
</script>


// WEBPACK FOOTER //
// CashFlowHistory.vue?ed140fbe